import fileDownload from "js-file-download";
import devicesService from "../shared/services/devicesService";

const REQUEST_DEVICES = "REQUEST_DEVICES";
const RSPONSE_DEVICES = "RSPONSE_DEVICES";
const REQUEST_DEVICES_FAILURE = "REQUEST_DEVICES_FAILURE";

const requestDevicesAction = () => {
  return {
    type: REQUEST_DEVICES,
  };
};

const responseDevicesAction = (data) => {
  return {
    type: RSPONSE_DEVICES,
    data,
  };
};

const requestDevicesFailureAction = (errors) => {
  return {
    type: REQUEST_DEVICES_FAILURE,
    errors,
  };
};

const getDevices = (searchTerm) => {
  return (dispatch) => {
    dispatch(requestDevicesAction());

    devicesService
      .getDevices(searchTerm)
      .then((result) => {
        dispatch(responseDevicesAction(result.data));
      })
      .catch((error) => {
        dispatch(requestDevicesFailureAction(error.response));
      });
  };
};

const SELECT_DEVICE = "SELECT_DEVICE";

const selectDeviceAction = (data) => {
  return {
    type: SELECT_DEVICE,
    data,
  };
};

const selectedDevice = (data = null) => {
  return (dispatch) => {
    dispatch(selectDeviceAction(data));
  };
};

const CLEAR_DEVICES = "CLEAR_DEVICES";

const clearDevicesAction = () => {
  return {
    type: CLEAR_DEVICES,
  };
};

const clearDevices = () => {
  return (dispatch) => {
    dispatch(clearDevicesAction());
  };
};

const REQUEST_DEVICE = "REQUEST_DEVICE";
const RESPONSE_DEVICE = "RSPONSE_DEVICE";
const REQUEST_DEVICE_FAILURE = "REQUEST_DEVICE_FAILURE";

const requestDeviceAction = () => {
  return {
    type: REQUEST_DEVICE,
  };
};

const responseDeviceAction = (data) => {
  return {
    type: RESPONSE_DEVICE,
    data,
  };
};

const requestDevicesFailurAction = (errors) => {
  return {
    type: REQUEST_DEVICE_FAILURE,
    errors,
  };
};

const getDevice = (id) => {
  return (dispatch) => {
    dispatch(requestDeviceAction());

    devicesService
      .getDevice(id)
      .then((result) => {
        dispatch(responseDeviceAction(result.data));
      })
      .catch((error) => {
        dispatch(requestDevicesFailurAction(error.response));
      });
  };
};

const REQUEST_UPDATE_DEVICE = "REQUEST_UPDATE_DEVICE";
const RESPONSE_UPDATE_DEVICE = "RESPONSE_UPDATE_DEVICE";
const REQUEST_UPDATE_DEVICE_FAILURE = "REQUEST_UPDATE_DEVICE_FAILURE";

const requestUpdateDeviceAction = () => {
  return {
    type: REQUEST_UPDATE_DEVICE,
  };
};

const responseUpdateDeviceAction = (data) => {
  return {
    type: RESPONSE_UPDATE_DEVICE,
    data,
  };
};

const requesUpdateDevicesFailurAction = (errors) => {
  return {
    type: REQUEST_UPDATE_DEVICE_FAILURE,
    errors,
  };
};

const updateDevice = (id, options) => {
  return (dispatch) => {
    dispatch(requestUpdateDeviceAction());

    devicesService
      .updateDevices(id, options)
      .then((result) => {
        dispatch(responseUpdateDeviceAction(options));
      })
      .catch((error) => {
        dispatch(requesUpdateDevicesFailurAction(error.response));
      });
  };
};

const REQUEST_PROTOCOL_MARKERS = "REQUEST_PROTOCOL_MARKERS";
const RESPONSE_PROTOCOL_MARKERS = "RESPONSE_PROTOCOL_MARKERS";
const REQUEST_PROTOCOL_MARKERS_FAILURE = "REQUEST_PROTOCOL_MARKERS_FAILURE";

const requesteProtocolMarkersAction = () => {
  return {
    type: REQUEST_PROTOCOL_MARKERS,
  };
};

const responseProtocolMarkersAction = (data) => {
  return {
    type: RESPONSE_PROTOCOL_MARKERS,
    data,
  };
};

const requesProtocolMarkersFailurAction = (errors) => {
  return {
    type: REQUEST_PROTOCOL_MARKERS_FAILURE,
    errors,
  };
};

const getProtocolMarkers = () => {
  return (dispatch) => {
    dispatch(requesteProtocolMarkersAction());

    devicesService
      .getDeviceProtocolMarkers()
      .then((result) => {
        dispatch(responseProtocolMarkersAction(result.data));
      })
      .catch((error) => {
        dispatch(requesProtocolMarkersFailurAction(error.response));
      });
  };
};

const REQUEST_CREATE_CONNECTED_SENSOR = "REQUEST_CREATE_CONNECTED_SENSOR";
const RESPONSE_CREATE_CONNECTED_SENSOR = "RESPONSE_CREATE_CONNECTED_SENSOR";
const REQUEST_CREATE_CONNECTED_SENSOR_FAILURE = "REQUEST_CREATE_CONNECTED_SENSOR_FAILURE";

const requesteCreateConnectedSendorAction = () => {
  return {
    type: REQUEST_CREATE_CONNECTED_SENSOR,
  };
};

const responseCreateConnectedSendorAction = (data) => {
  return {
    type: RESPONSE_CREATE_CONNECTED_SENSOR,
    data,
  };
};

const requesCreateConnectedSendorFailurAction = (errors) => {
  return {
    type: REQUEST_CREATE_CONNECTED_SENSOR_FAILURE,
    errors,
  };
};

const createConnectedSensor = (options) => {
  return (dispatch) => {
    dispatch(requesteCreateConnectedSendorAction());

    devicesService
      .createConnectedSensor(options)
      .then((result) => {
        dispatch(responseCreateConnectedSendorAction(result.data));
      })
      .catch((error) => {
        dispatch(requesCreateConnectedSendorFailurAction(error.response.data));
      });
  };
};

const REQUEST_DELETE_CONNECTED_SENSOR = "REQUEST_DELETE_CONNECTED_SENSOR";
const RESPONSE_DELETE_CONNECTED_SENSOR = "RESPONSE_DELETE_CONNECTED_SENSOR";
const REQUEST_DELETE_CONNECTED_SENSOR_FAILURE = "REQUEST_DELETE_CONNECTED_SENSOR_FAILURE";

const requesteDeleteConnectedSendorAction = () => {
  return {
    type: REQUEST_DELETE_CONNECTED_SENSOR,
  };
};

const responseDeleteConnectedSendorAction = (data) => {
  return {
    type: RESPONSE_DELETE_CONNECTED_SENSOR,
    data,
  };
};

const requesDeleteConnectedSendorFailurAction = (errors) => {
  return {
    type: REQUEST_DELETE_CONNECTED_SENSOR_FAILURE,
    errors,
  };
};

const deleteConnectedSensor = (options) => {
  return (dispatch) => {
    dispatch(requesteDeleteConnectedSendorAction());

    devicesService
      .deleteConnectedSensor(options)
      .then((result) => {
        dispatch(responseDeleteConnectedSendorAction(options.id));
      })
      .catch((error) => {
        dispatch(requesDeleteConnectedSendorFailurAction(error.response.data));
      });
  };
};

const REQUEST_CREATE_CALEBRATION = "REQUEST_CREATE_CALEBRATION";
const RESPONSE_CREATE_CALEBRATION = "RESPONSE_CREATE_CALEBRATION";
const REQUEST_CREATE_CALEBRATION_FAILURE = "REQUEST_CREATE_CALEBRATION_FAILURE";

const requesteCreateCalibrationAction = () => {
  return {
    type: REQUEST_CREATE_CALEBRATION,
  };
};

const responseCreateCalibrationAction = (data) => {
  return {
    type: RESPONSE_CREATE_CALEBRATION,
    data,
  };
};

const requesCreateCalibrationAction = (errors) => {
  return {
    type: REQUEST_CREATE_CALEBRATION_FAILURE,
    errors,
  };
};

const createCalibration = (options) => {
  return (dispatch) => {
    dispatch(requesteCreateCalibrationAction());

    devicesService
      .createCalibration(options)
      .then((result) => {
        options.calibration.id = result.data.id;
        dispatch(responseCreateCalibrationAction(options));
      })
      .catch((error) => {
        dispatch(requesCreateCalibrationAction(error.response.data));
      });
  };
};

const REQUEST_DELETE_CALEBRATION = "REQUEST_DELETE_CALEBRATION";
const RESPONSE_DELETE_CALEBRATION = "RESPONSE_DELETE_CALEBRATION";
const REQUEST_DELETE_CALEBRATION_FAILURE = "REQUEST_DELETE_CALEBRATION_FAILURE";

const requesteeDeleteCalibrationAction = () => {
  return {
    type: REQUEST_DELETE_CALEBRATION,
  };
};

const responseDeleteCalibrationAction = (data) => {
  return {
    type: RESPONSE_DELETE_CALEBRATION,
    data,
  };
};

const requesDeleteCalibrationAction = (errors) => {
  return {
    type: REQUEST_DELETE_CALEBRATION_FAILURE,
    errors,
  };
};

const deleteCalibration = (options) => {
  return (dispatch) => {
    dispatch(requesteeDeleteCalibrationAction());

    devicesService
      .deleteCalibration(options)
      .then((result) => {
        dispatch(responseDeleteCalibrationAction(options));
      })
      .catch((error) => {
        dispatch(requesDeleteCalibrationAction(error.response.data));
      });
  };
};

const REQUEST_REPLACE_DEVICE = "REQUEST_REPLACE_DEVICE";
const RESPONSE_REPLACE_DEVICE = "RESPONSE_REPLACE_DEVICE";
const REQUEST_REPLACE_DEVICE_FAILURE = "REQUEST_REPLACE_DEVICE_FAILURE";

const requesteeReplaceDeviceAction = () => {
  return {
    type: REQUEST_REPLACE_DEVICE,
  };
};

const responseReplaceDeviceAction = () => {
  return {
    type: RESPONSE_REPLACE_DEVICE,
  };
};

const requesReplaceDeviceAction = (errors) => {
  return {
    type: REQUEST_REPLACE_DEVICE_FAILURE,
    errors,
  };
};

const replaceDevice = (options) => {
  return (dispatch) => {
    dispatch(requesteeReplaceDeviceAction());

    devicesService
      .replaceDevices(options)
      .then((result) => {
        dispatch(responseReplaceDeviceAction());
      })
      .catch((error) => {
        dispatch(requesReplaceDeviceAction(error.response.data));
      });
  };
};

const CLEAR_CURRENT_DEVICE = "CLEAR_CURRENT_DEVICE";

const clearCurrentDeviceAction = () => {
  return {
    type: CLEAR_CURRENT_DEVICE,
  };
};

const clearCurrentDevice = () => {
  return (dispatch) => {
    dispatch(clearCurrentDeviceAction());
  };
};

const REQUEST_DEVICE_PATTERNS = "REQUEST_DEVICE_PATTERNS";
const RESPONSE_DEVICE_PATTERNS = "RESPONSE_DEVICE_PATTERNS";
const REQUEST_DEVICE_PATTERNS_FAILURE = "REQUEST_DEVICE_PATTERNS_FAILURE";

const requesteeDevicePatternsAction = () => {
  return {
    type: REQUEST_DEVICE_PATTERNS,
  };
};

const responseDevicePatternsAction = (data) => {
  return {
    type: RESPONSE_DEVICE_PATTERNS,
    data,
  };
};

const requesDevicePatternsFailureAction = (errors) => {
  return {
    type: REQUEST_DEVICE_PATTERNS_FAILURE,
    errors,
  };
};

const getDevicePatterns = () => {
  return (dispatch) => {
    dispatch(requesteeDevicePatternsAction());

    devicesService
      .devicePatterns()
      .then((result) => {
        dispatch(responseDevicePatternsAction(result.data));
      })
      .catch((error) => {
        dispatch(requesDevicePatternsFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_DEVICE = "REQUEST_CREATE_DEVICE";
const RESPONSE_CREATE_DEVICE = "RESPONSE_CREATE_DEVICE";
const REQUEST_CREATE_DEVICE_FAILURE = "REQUEST_CREATE_DEVICE_FAILURE";

const requesteeCreateDeviceAction = () => {
  return {
    type: REQUEST_CREATE_DEVICE,
  };
};

const responseCreateDeviceAction = (data) => {
  return {
    type: RESPONSE_CREATE_DEVICE,
    data,
  };
};

const requesCreateDeviceFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_DEVICE_FAILURE,
    errors,
  };
};

const createDevice = (options) => {
  return (dispatch) => {
    dispatch(requesteeCreateDeviceAction());

    devicesService
      .createDevice(options)
      .then((result) => {
        dispatch(responseCreateDeviceAction(result.data));
      })
      .catch((error) => {
        dispatch(requesCreateDeviceFailureAction(error.response));
      });
  };
};

const REQUEST_UPLOAD_CALIBRATIONS = "REQUEST_UPLOAD_CALIBRATIONS";
const RESPONSE_UPLOAD_CALIBRATIONS = "RESPONSE_UPLOAD_CALIBRATIONS";
const REQUEST_UPLOAD_CALIBRATIONS_FAILURE = "REQUEST_UPLOAD_CALIBRATIONS_FAILURE";

const requesteeUploadCalibrationsAction = () => {
  return {
    type: REQUEST_UPLOAD_CALIBRATIONS,
  };
};

const responseUploadCalibrationsAction = (id, data) => {
  return {
    type: RESPONSE_UPLOAD_CALIBRATIONS,
    id,
    data,
  };
};

const requesUploadCalibrationsFailureAction = (errors) => {
  return {
    type: REQUEST_UPLOAD_CALIBRATIONS_FAILURE,
    errors,
  };
};

const uploadCalibrations = (id, options) => {
  return (dispatch) => {
    dispatch(requesteeUploadCalibrationsAction());

    devicesService
      .uploadCalibrations(id, options)
      .then((result) => {
        dispatch(responseUploadCalibrationsAction(id, result.data));
      })
      .catch((error) => {
        dispatch(requesUploadCalibrationsFailureAction(error.response));
      });
  };
};

const REQUEST_DOWNLOAD_CALIBRATIONS = "REQUEST_DOWNLOAD_CALIBRATIONS";
const RESPONSE_DOWNLOAD_CALIBRATIONS = "RESPONSE_DOWNLOAD_CALIBRATIONS";
const REQUEST_DOWNLOAD_CALIBRATIONS_FAILURE = "REQUEST_DOWNLOAD_CALIBRATIONS_FAILURE";

const requesteeDownloadCalibrationsAction = () => {
  return {
    type: REQUEST_DOWNLOAD_CALIBRATIONS,
  };
};

const responseDownloadCalibrationsAction = () => {
  return {
    type: RESPONSE_DOWNLOAD_CALIBRATIONS,
  };
};

const requesDownloadCalibrationsFailureAction = (errors) => {
  return {
    type: REQUEST_DOWNLOAD_CALIBRATIONS_FAILURE,
    errors,
  };
};

const downloadCalibrations = (id, imei, sensorName) => {
  return (dispatch) => {
    dispatch(requesteeDownloadCalibrationsAction());

    devicesService
      .downloadCalibrations(id)
      .then((result) => {
        fileDownload(result.data, `${imei} ${sensorName}.json`);
        dispatch(responseDownloadCalibrationsAction());
      })
      .catch((error) => {
        dispatch(requesDownloadCalibrationsFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_DEVICE_COMMAND = "REQUEST_CREATE_DEVICE_COMMAND";
const RESPONSE_CREATE_DEVICE_COMMAND = "RESPONSE_CREATE_DEVICE_COMMAND";
const REQUEST_CREATE_DEVICE_COMMAND_FAILURE = "REQUEST_CREATE_DEVICE_COMMAND_FAILURE";

const requesteeCreateDeviceCommandAction = () => {
  return {
    type: REQUEST_CREATE_DEVICE_COMMAND,
  };
};

const responseCreateDeviceCommandAction = (data) => {
  return {
    type: RESPONSE_CREATE_DEVICE_COMMAND,
    data,
  };
};

const requesCreateDeviceCommandFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_DEVICE_COMMAND_FAILURE,
    errors,
  };
};

const createCommand = (id, options) => {
  return (dispatch) => {
    dispatch(requesteeCreateDeviceCommandAction());

    devicesService
      .createCommand(id, options)
      .then((result) => {
        dispatch(responseCreateDeviceCommandAction({ id: id, ...options }));
      })
      .catch((error) => {
        dispatch(requesCreateDeviceCommandFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_DEVICE_COMMAND = "REQUEST_DELETE_DEVICE_COMMAND";
const RESPONSE_DELETE_DEVICE_COMMAND = "RESPONSE_DELETE_DEVICE_COMMAND";
const REQUEST_DELETE_DEVICE_COMMAND_FAILURE = "REQUEST_DELETE_DEVICE_COMMAND_FAILURE";

const requesteeDeleteDeviceCommandAction = () => {
  return {
    type: REQUEST_DELETE_DEVICE_COMMAND,
  };
};

const responseDeleteDeviceCommandAction = (data) => {
  return {
    type: RESPONSE_DELETE_DEVICE_COMMAND,
    data,
  };
};

const requesDeleteDeviceCommandFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_DEVICE_COMMAND_FAILURE,
    errors,
  };
};

const deleteCommand = (id) => {
  return (dispatch) => {
    dispatch(requesteeDeleteDeviceCommandAction());

    devicesService
      .deleteCommand(id)
      .then((result) => {
        dispatch(responseDeleteDeviceCommandAction({ id: id }));
      })
      .catch((error) => {
        dispatch(requesDeleteDeviceCommandFailureAction(error.response));
      });
  };
};

export {
  REQUEST_DEVICES,
  RSPONSE_DEVICES,
  REQUEST_DEVICES_FAILURE,
  getDevices,
  SELECT_DEVICE,
  selectedDevice,
  CLEAR_DEVICES,
  clearDevices,
  REQUEST_DEVICE,
  RESPONSE_DEVICE,
  REQUEST_DEVICE_FAILURE,
  getDevice,
  REQUEST_UPDATE_DEVICE,
  RESPONSE_UPDATE_DEVICE,
  REQUEST_UPDATE_DEVICE_FAILURE,
  updateDevice,
  REQUEST_PROTOCOL_MARKERS,
  RESPONSE_PROTOCOL_MARKERS,
  REQUEST_PROTOCOL_MARKERS_FAILURE,
  getProtocolMarkers,
  REQUEST_CREATE_CONNECTED_SENSOR,
  RESPONSE_CREATE_CONNECTED_SENSOR,
  REQUEST_CREATE_CONNECTED_SENSOR_FAILURE,
  createConnectedSensor,
  REQUEST_DELETE_CONNECTED_SENSOR,
  RESPONSE_DELETE_CONNECTED_SENSOR,
  REQUEST_DELETE_CONNECTED_SENSOR_FAILURE,
  deleteConnectedSensor,
  REQUEST_CREATE_CALEBRATION,
  RESPONSE_CREATE_CALEBRATION,
  REQUEST_CREATE_CALEBRATION_FAILURE,
  createCalibration,
  REQUEST_DELETE_CALEBRATION,
  RESPONSE_DELETE_CALEBRATION,
  REQUEST_DELETE_CALEBRATION_FAILURE,
  deleteCalibration,
  REQUEST_REPLACE_DEVICE,
  RESPONSE_REPLACE_DEVICE,
  REQUEST_REPLACE_DEVICE_FAILURE,
  replaceDevice,
  CLEAR_CURRENT_DEVICE,
  clearCurrentDevice,
  REQUEST_DEVICE_PATTERNS,
  RESPONSE_DEVICE_PATTERNS,
  REQUEST_DEVICE_PATTERNS_FAILURE,
  getDevicePatterns,
  REQUEST_CREATE_DEVICE,
  RESPONSE_CREATE_DEVICE,
  REQUEST_CREATE_DEVICE_FAILURE,
  createDevice,
  REQUEST_UPLOAD_CALIBRATIONS,
  RESPONSE_UPLOAD_CALIBRATIONS,
  REQUEST_UPLOAD_CALIBRATIONS_FAILURE,
  uploadCalibrations,
  REQUEST_DOWNLOAD_CALIBRATIONS,
  RESPONSE_DOWNLOAD_CALIBRATIONS,
  REQUEST_DOWNLOAD_CALIBRATIONS_FAILURE,
  downloadCalibrations,
  REQUEST_CREATE_DEVICE_COMMAND,
  RESPONSE_CREATE_DEVICE_COMMAND,
  REQUEST_CREATE_DEVICE_COMMAND_FAILURE,
  createCommand,
  REQUEST_DELETE_DEVICE_COMMAND,
  RESPONSE_DELETE_DEVICE_COMMAND,
  REQUEST_DELETE_DEVICE_COMMAND_FAILURE,
  deleteCommand,
};
